module.exports = __webpack_public_path__ + "assets/img/32_627_big.b46b0cd7.jpg";